import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'

export default function BasicBarChart({
  compStyle = { height: '400px', width: '100%' },
  seriesData = [],
  axisLabelConfig = {},
  xAxisData = [],
  barColor = '#5470c6',
  yAxisName = '',
  xAxisName = '',
  xNameLocation = '', //'start' 'middle' 'end' วางชื่อตรงกลางของแกน
  xNameGap = 0, // ระยะห่างจากแกน (เพิ่มค่าเพื่อให้ห่างมากขึ้น)
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  const optionChart = {
    tooltip: {
      trigger: 'item',
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLabel: axisLabelConfig,
      name: xAxisName,
      nameLocation: xNameLocation, // วางชื่อตรงกลางของแกน
      nameGap: xNameGap, // ระยะห่างจากแกน (เพิ่มค่าเพื่อให้ห่างมากขึ้น)
    },
    yAxis: {
      type: 'value',
      name: yAxisName,
    },
    series: [
      {
        data: seriesData,
        type: 'bar',
        itemStyle: {
          color: barColor, // สีน้ำเงิน
        },
      },
    ],
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)
      onClickCheart(params.data)
    },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts option={chartOption} style={compStyle} onEvents={onEvents} />
    </div>
  )
}
